import { undefinedObjectToNull } from '@shared/api/middleware/mappingAPI/helpers'
import { TypeRestoplaceSlotBackend } from '@shared/api/middleware/mappingAPI/restoplaceSlot/types'
import { TypeExtendedScheduleTimeSlot } from '@shared/types/schedule/types'

const isDevParam = typeof window === 'object' && window.location.search.indexOf('is_dev=true') > 0

/**
 * @description преобразование слотов из бэкенда в формат для бронирования
 */
export const mappingRestoplaceSlot = (object: TypeRestoplaceSlotBackend): TypeExtendedScheduleTimeSlot => {
  isDevParam && console.log('!!! mappingRestoplaceSlot: object', object)

  try {
    const dateSlotStart = new Date(object.from)
    // получаем часы и минуты в 24-часовом формате
    const hours = dateSlotStart.getHours().toString().padStart(2, '0')
    const minutes = dateSlotStart.getMinutes().toString().padStart(2, '0')
    const value = `${hours}:${minutes}`
    const date = dateSlotStart.toJSON()

    isDevParam && console.log('!!! mappingRestoplaceSlot: value', value)
    isDevParam && console.log('!!! mappingRestoplaceSlot: date', date)
    isDevParam && console.log('!!! mappingRestoplaceSlot: free', object.free)
    isDevParam && console.log('!!! mappingRestoplaceSlot: counts', object.counts)

    return undefinedObjectToNull({
      value: value,
      date: date,
      free: object.free,
      counts: object.counts,
    })
  } catch (error) {
    console.error(error)
    return null
  }
}
